module.exports = __webpack_public_path__ + "img/image.04fcd070.png";